import React, { FC, useMemo, useRef } from 'react';
import { useHistory } from 'react-router';

import { useModal } from 'context/ModalProvider/useModal';
import { DataGrid } from 'devextreme-react';
import $createStore from 'utils/create-store-instance';

import { BlockAccountModal } from '../modals/BlockAccountModal';
import { ChangePasswordModal } from '../modals/ChangePasswordModal';
import { CreateUserModal } from '../modals/CreateUserModal';
import { EditUserModal } from '../modals/EditUserModal';
import { AccountListPage } from '../Pages';

export const AccountsListScreen: FC = () => {
  const { showModal } = useModal();
  const history = useHistory();
  const dataGridRef = useRef<DataGrid | null>(null);

  const dataSource: any = useMemo(() => {
    return $createStore('/v1/Account', 'id');
  }, []);

  const handleRefresh = () => dataGridRef.current?.instance.refresh();

  const handleCreateAccount = () => {
    showModal(<CreateUserModal onRefresh={handleRefresh} />);
  };

  const handleEditAccount = (id: number) => {
    showModal(<EditUserModal id={id} onRefresh={handleRefresh} />);
  };

  const handleBlockAccount = (id: number, isBlocked: boolean) => {
    showModal(<BlockAccountModal id={id} isBlocked={isBlocked} onRefresh={handleRefresh} />);
  };

  const handleChangePassword = (id: number) => {
    showModal(<ChangePasswordModal id={id} />);
  };

  const handleOpenHisoty = (id: number) => {
    history.push(`/accounts/history/${id}`);
  };

  return (
    <AccountListPage
      accountList={dataSource}
      onCreate={handleCreateAccount}
      onEdit={handleEditAccount}
      onBlock={handleBlockAccount}
      onChangePassword={handleChangePassword}
      onOpenHistory={handleOpenHisoty}
      ref={dataGridRef}
    />
  );
};
